<ayen-map [apiLoaded]="apiLoaded" #ayenMap [lat]="latitude" [lang]="longitude" (mapValues)="mapValues($event)"></ayen-map>
